import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import DashboardPageUI from './DashboardPageUI'
import { getRepairingTicketApi, StatusCountChangeApi } from '../../apis/repairing.api'
import { openModal } from '../../store/actions/modalAction';
import { useDispatch, useSelector } from 'react-redux';
import { callApiAction } from '../../store/actions/commonAction';
import moment from 'moment';
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { Edit, Visibility } from '@mui/icons-material';
import CustomerInformation from './CustomerInformation';
import { BUTTON_TYPE, STATUS, USER_ROLES } from '../../utils/constants';
import UpdateCreateQueryController from './UpdateCreateQueryController';
import { statusAction, statusActionFilters, statusCountActionFilters } from '../../store/actions/statusAction';
import { toTitleCase } from '../../utils/main';

const ActionComponent = memo(({ params, setParams, statusPass }) => {
  const dispatch = useDispatch()

  const onEdit = () => {
    dispatch(openModal(<UpdateCreateQueryController id={params._id} statusPass={statusPass === STATUS.ALL ? params?.status[0]?.status_role : statusPass}
    />, "md", false, "UpdateQuery"))
  }

  const onInfo = () => {
    dispatch(
      openModal(
        <CustomerInformation id={params?._id} statusPass={statusPass} />
        ,
        "md",
        false,
        "CustomerInformation"
      )
    );
  };
  const All = statusPass === STATUS.ALL && [STATUS.QC_CHECKED, STATUS.DEVICE_RECEIVED, STATUS.REPAIR_START, STATUS.PAYMENT_RECEIVED, STATUS.REPAIR_DEMO].includes(params?.status[0]?.status_role)

  return <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
    <Tooltip title={"Customer Information"}>
      <IconButton size="inherit" onClick={onInfo}>
        <Visibility color="info" fontSize="inherit" />
      </IconButton>
    </Tooltip>

    {(All || (statusPass === STATUS.QC_CHECKED) || (statusPass === STATUS.DEVICE_RECEIVED) || (statusPass === STATUS.REPAIR_START) || (statusPass === STATUS.PAYMENT_RECEIVED) || (statusPass === STATUS.REPAIR_DEMO)) && <IconButton size="inherit" onClick={onEdit}>
      <Edit color="info" fontSize="inherit" />
    </IconButton>}
  </Box>
})

const DashboardPageControllerRepair = () => {
  const dispatch = useDispatch();
  const [RepairstatusButton, setRepairstatusButton] = useState(BUTTON_TYPE.Work_In_Progress)
  const [STATUSWiseData, setSTATUSWiseData] = useState(STATUS.ALL)
  const statusPass = useRef();
  statusPass.current = STATUSWiseData
  const [productid, setProductid] = useState({
    _id: "",
    name: ""
  })

  const ProductWiseLeadTimeDate = (product) => {
    switch (product) {
      case "67640e7ac44862df4383cc53":
      case "67640e65c44862df4383cc4d":
      case "67640e81c44862df4383cc56":
        return -1;

      default:
        return -9;
    }
  };

  const columns = useMemo(() => {

    const LeadTime = (date) => {
      const time = date?.lead_time
        ? date?.lead_time
        : date?.logs?.length > 1
          ? date?.logs[1]?.date
          : date?.updatedAt;

      const momentDate = moment(time);

      if (!momentDate.isValid()) {
        return "";
      }

      const leadTimeDate = momentDate.clone().startOf("day");
      const currentDate = moment().startOf("day");

      const daysDifference = leadTimeDate.diff(currentDate, "days");

      const productLeadTime = ProductWiseLeadTimeDate(
        date?.product_id?._id
      );

      return daysDifference >= productLeadTime
        ? ""
        : RepairstatusButton === BUTTON_TYPE.Solved
          ? ""
          : "red";
    };

    return [

      {
        id: 2,
        fieldName: "createdAt",
        label: "Query Created Date",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{moment(params?.createdAt).format("DD/MM/YYYY")}</Typography>
      },
      {
        id: 8,
        fieldName: "updatedAt",
        label: "Query Updated Date",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{moment(params?.updatedAt).format("DD/MM/YYYY")}</Typography>
      },
      {
        id: 1,
        fieldName: "ticket_no",
        label: "Ticket No",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{params?.ticket_no}</Typography>
      },
      {
        id: 3,
        fieldName: "customer_name",
        label: "Customer Name",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{toTitleCase(params?.customer_name)}</Typography>
      },
      {
        id: 5,
        fieldName: "customer_phone",
        label: "Phone",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{params?.customer_phone}</Typography>
      },
      {
        id: 4,
        fieldName: "box_id",
        label: "Box Id",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{params?.box_id}</Typography>
      },
      {
        id: 6,
        fieldName: "new_box_id",
        label: "New Box Id",
        align: "left",
        sort: true,
        hide: STATUSWiseData !== STATUS.REPLACEMENT_COMPLETE,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{params?.new_box_id ? params?.new_box_id : "NA"}</Typography>
      },
      {
        id: 9,
        fieldName: "",
        label: "Time Left",
        align: "center",
        justify: "center",
        sort: false,
        hide: RepairstatusButton === BUTTON_TYPE.Solved,
        renderValue: (params) => {
          const leadTimeDate = params?.lead_time
            ? moment(params?.lead_time)
            : params?.logs?.length > 1
              ? moment(params?.logs[1]?.date)
              : moment(params?.updatedAt);

          if (!leadTimeDate.isValid()) {
            return <Typography>NA</Typography>;
          }

          const productLeadTime = ProductWiseLeadTimeDate(
            params?.product_id?._id
          );

          const allowedDays = -productLeadTime;

          const deadline = leadTimeDate
            .clone()
            .add(allowedDays, "days")
            .startOf("day");

          const today = moment().startOf("day");

          const daysLeft = deadline.diff(today, "days");

          const isOverdue = LeadTime(params) === "red";

          return (
            <Typography
              sx={{
                color: isOverdue ? "red" : "green",
              }}
            >
              {daysLeft >= 0 ? (
                `${daysLeft + 1} days left`
              ) : (
                <Chip
                  label="Over Due"
                  sx={{
                    color: "white",
                    backgroundColor: "rgba(224, 20, 20, 0.8)",
                  }}
                />
              )}
            </Typography>
          );
        },
      },

      {
        id: 7,
        fieldName: "",
        label: "Action",

        align: "right",
        renderValue: (params, setParams) => (
          <ActionComponent
            params={params}
            setParams={setParams}
            statusPass={statusPass.current}
          />
        ),
      },
    ]
  },
    [STATUSWiseData, RepairstatusButton]
  );
  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ['customer_name', 'box_id', 'customer_phone', 'ticket_no'],
    role: "",
    sort: "updatedAt",
    sortDirection: -1,
  });

  const [loadingCount, setLoadingCount] = useState(false);
  const [loading, setLoading] = useState(false);
  const statusData = useSelector((state) => state)
  const list = useRef();
  list.current = statusData.statusReducer.status_data

  const fetchList = useCallback(() => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getRepairingTicketApi({ ...filters, status_role: STATUSWiseData, product_id: productid?._id, parentStatus: RepairstatusButton }),
        (response) => {
          dispatch(statusAction(response));
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  }, [dispatch, filters, STATUSWiseData, productid, RepairstatusButton])

  const [CountStatus, setCountStatus] = useState()


  const fetchCountDataAll = useCallback(() => {
    setLoadingCount(true);
    dispatch(
      callApiAction(
        async () => await StatusCountChangeApi({ role: USER_ROLES.REPAIR_TEAM, product_id: productid?._id }),
        async (response) => {
          setCountStatus({ response });

          setLoadingCount(false);
        },
        (err) => {
          setCountStatus({ err });
          setLoadingCount(false);
        }
      )
    );
  }, [dispatch, productid])

  useEffect(() => {
    if (JSON.stringify(filters) === JSON.stringify(statusData.statusReducer.filters)) {
      fetchList();
    } else {
      dispatch(statusActionFilters(filters));
    }
  }, [dispatch, fetchList, STATUSWiseData, statusData.statusReducer.filters, filters, productid._id]);

  useEffect(() => {
    if (statusData.statusReducer.Count !== -1 || productid._id) {
      fetchCountDataAll();
    } else {
      dispatch(statusCountActionFilters(1));
    }
  }, [dispatch, fetchCountDataAll, statusData.statusReducer.Count, productid._id])

  return (
    <DashboardPageUI
      CountStatus={CountStatus}
      columns={columns}
      list={list.current}
      loading={loading}
      loadingCount={loadingCount}
      filters={filters}
      setFilters={setFilters}
      RepairstatusButton={RepairstatusButton}
      setRepairstatusButton={setRepairstatusButton}
      setSTATUSWiseData={setSTATUSWiseData}
      STATUSWiseData={STATUSWiseData}
      setProductid={setProductid}
      productid={productid}
    />
  )
}

export default DashboardPageControllerRepair